import { defaultDataIdFromObject, InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import env from '../config/env';
import authLink from '../graphql/auth-link';
import errorLink from '../graphql/error-link';
import { IProduct } from './types';

const httpLink = new HttpLink({
  uri: env.api.host + env.api.paths.graphql,
});
const link = ApolloLink.from([authLink, errorLink, httpLink]);
const cache = new InMemoryCache({
  dataIdFromObject: object => {
    switch (object.__typename) {
      case 'Product':
        return `product:${object.id}:${(object as IProduct).salesOrg}`;
      default:
        return defaultDataIdFromObject(object);
    }
  },
});

export default new ApolloClient({
  cache,
  link,
  resolvers: {},
});
